import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
Vue.use(Vuex)

const state = {
  ip: 'app.tkcooldog.cc',  //app.tkcooldog.cc //bbapp.tkcooldog.cc //zzapp.tkcooldog.cc
  edit: false,
  refreshData: false,
  sysUserInfo: localStorage.getItem('sysUserInfo') ? localStorage.getItem('sysUserInfo') : null,
  footer: localStorage.getItem('footer') ? localStorage.getItem('footer') : true,
  end: localStorage.getItem('end') ? localStorage.getItem('end') : '',
  start: localStorage.getItem('start') ? localStorage.getItem('start') : '',
  isHis: localStorage.getItem('isHis') ? localStorage.getItem('isHis') : 0,
  type: localStorage.getItem('type') ? localStorage.getItem('type') : null,
  selectBtFiveList: localStorage.getItem('selectBtFiveList') ? localStorage.getItem('selectBtFiveList') : null,
  selectBtFourList: localStorage.getItem('selectBtFourList') ? localStorage.getItem('selectBtFourList') : null,
  selectBtThreeList: localStorage.getItem('selectBtThreeList') ? localStorage.getItem('selectBtThreeList') : null,
  selectBtTwoList: localStorage.getItem('selectBtTwoList') ? localStorage.getItem('selectBtTwoList') : null,
  selectBtOneList: localStorage.getItem('selectBtOneList') ? localStorage.getItem('selectBtOneList') : null,
  selectFtFiveList: localStorage.getItem('selectFtFiveList') ? localStorage.getItem('selectFtFiveList') : null,
  selectFtFourList: localStorage.getItem('selectFtFourList') ? localStorage.getItem('selectFtFourList') : null,
  selectFtThreeList: localStorage.getItem('selectFtThreeList') ? localStorage.getItem('selectFtThreeList') : null,
  selectFtTwoList: localStorage.getItem('selectFtTwoList') ? localStorage.getItem('selectFtTwoList') : null,
  selectFtOneList: localStorage.getItem('selectFtOneList') ? localStorage.getItem('selectFtOneList') : [],
  cpTypeName: localStorage.getItem('cpTypeName') ? localStorage.getItem('cpTypeName') : '',
  selectedG2: localStorage.getItem('selectedG2') ? localStorage.getItem('selectedG2') : false,
  selectedG3: localStorage.getItem('selectedG3') ? localStorage.getItem('selectedG3') : false,
  selectedG4: localStorage.getItem('selectedG4') ? localStorage.getItem('selectedG4') : false,
  selectedG5: localStorage.getItem('selectedG5') ? localStorage.getItem('selectedG5') : false,
  selectedG6: localStorage.getItem('selectedG6') ? localStorage.getItem('selectedG6') : false,
  selectedG7: localStorage.getItem('selectedG7') ? localStorage.getItem('selectedG7') : false,
  selectedG8: localStorage.getItem('selectedG8') ? localStorage.getItem('selectedG8') : false,
  selectedMN: localStorage.getItem('selectedMN') ? localStorage.getItem('selectedMN') : null, // 选中MN的哪一种
  selectedGToggle: localStorage.getItem('selectedGToggle') ? localStorage.getItem('selectedGToggle') : false, // 是否选中单关
  GToggle: localStorage.getItem('GToggle') ? localStorage.getItem('GToggle') : false, // 单关是否可以被显示0否1是
  ggType: localStorage.getItem('ggType') ? localStorage.getItem('ggType') : 0, // 过关方式0：M串N;1：自由过关
  playTypes: localStorage.getItem('playTypes') ? localStorage.getItem('playTypes') : null,
  remark: localStorage.getItem('remark') ? localStorage.getItem('remark') : null, // 备注
  zcount: localStorage.getItem('zcount') ? localStorage.getItem('zcount') : null, // //投注数
  num: localStorage.getItem('num') ? localStorage.getItem('num') : null, // 份数
  multiple: localStorage.getItem('multiple') ? localStorage.getItem('multiple') : null, // 倍数
  bonus: localStorage.getItem('bonus') ? localStorage.getItem('bonus') : 0, // 理论奖金
  monery: localStorage.getItem('monery') ? localStorage.getItem('monery') : 0, // 投注金额
  dcount: localStorage.getItem('dcount') ? localStorage.getItem('dcount') : 0, // 单关场次
  count: localStorage.getItem('count') ? localStorage.getItem('count') : 0, // 总场次
  // 市
  cityList: localStorage.getItem('cityList') ? localStorage.getItem('cityList') : null,
  // 省
  provinceList: localStorage.getItem('provinceList') ? localStorage.getItem('provinceList') : null,
  // 注册用户登录信息
  registerUser: localStorage.getItem('registerUser') ? localStorage.getItem('registerUser') : null,
  // 若localSorage存在token，将值赋给Vuex.state.token
  token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
  // 菜单
  menuData: {
    list: [
      {
        index: 'ft',
        label: '竞彩足球',
        url: '/ft',
        icon: 'el-icon-s-order',
        src: '1'
      },
      {
        index: 'bt',
        label: '竞彩篮球',
        url: '/bt',
        icon: 'el-icon-s-order',
        src: '2'
      },
      {
        index: 'wq',
        label: '往期数据',
        url: '',
        icon: 'el-icon-s-order',
        children: [{
          index: 'ftHis',
          label: '竞彩足球',
          url: '/ftHis',
          icon: 'el-icon-s-order',
          src: '1'
        }, {
          index: 'btHis',
          label: '竞彩篮球',
          url: '/btHis',
          icon: 'el-icon-s-order',
          src: '2'
        }]
      },
      {
        index: 'record',
        label: '订单管理',
        url: '/record',
        icon: 'el-icon-s-order'
      },
      /* {
        index: 'appOrderManage',
        label: 'APP订单管理',
        url: '/appOrderManage',
        icon: 'el-icon-s-order'
      }, */
      {
        index: 'appLogin',
        label: '一键打票',
        url: '/appLogin',
        icon: 'el-icon-s-order'
      },
      {
        index: 'recordTotal',
        label: '订单统计',
        url: '/recordTotal',
        icon: 'el-icon-s-order'
      },
      /* {
        index: 'appRecordTotal',
        label: 'APP订单统计',
        url: '/recordTotal',
        icon: 'el-icon-s-order'
      }, */ {
        index: 'sysUserInfo',
        label: '用户管理',
        url: '/sysUserInfo',
        icon: 'el-icon-user'
      }, /*{
        index: 'appSysUserInfo',
        label: 'APP用户管理',
        url: '/appSysUserInfo',
        icon: 'el-icon-user'
      } ,*/
      {
        index: 'sysRole',
        label: '角色管理',
        url: '/sysRole',
        icon: 'el-icon-coordinate'
      }
    ],
    collapse: false
  }
}

const mutations = {
  setRefreshData (state, value) {
    state.refreshData = value
  },
  // 切换菜单状态
  switchCollapseMenu (state, value) {
    if (value != null) {
      state.menuData.collapse = value
    } else {
      state.menuData.collapse = !state.menuData.collapse
    }
    window.localStorage.setItem('MENU_STATUS', state.menuData.collapse)
  },
  // 市
  setCityList (state, cityList) {
    state.cityList = cityList
    localStorage.setItem('cityList', JSON.stringify(cityList))
  },
  // 省
  setProvinceList (state, provinceList) {
    state.provinceList = provinceList
    localStorage.setItem('provinceList', JSON.stringify(provinceList))
  },
  // 设置已登录的用户信息
  setRegisterUserInfo (state, registerUser) {
    state.registerUser = registerUser
    localStorage.setItem('registerUser', JSON.stringify(registerUser))
  },
  // 设置已登录的用户信息
  setSysUserInfo (state, sysUserInfo) {
    state.sysUserInfo = sysUserInfo
    localStorage.setItem('sysUserInfo', JSON.stringify(sysUserInfo))
  },
  setToken (state, token) {
    localStorage.setItem('token', token)

    const expirationDate = new Date().getTime() + 168 * 3600 * 1000 // 设置过期时间为7天
    localStorage.setItem('expirationDate', expirationDate)

    state.token = token
  },
  logout (state) {
    localStorage.removeItem('token')
    state.token = null
    localStorage.removeItem('sysUserInfo')
    state.sysUserInfo = null
    localStorage.removeItem('expirationDate')
  },
  // 我页面中写了退出登录的按钮所以补了一个logout用来清空localStorage中的数据
  /* logout (state) {
    localStorage.removeItem('token')
    state.token = null
    localStorage.removeItem('registerUser')
    state.registerUser = null
    localStorage.removeItem('expirationDate')
    /!* localStorage.removeItem('provinceList')
    state.provinceList = null
    localStorage.removeItem('cityList')
    state.cityList = null *!/
    // 我写的RSA加密需向后端获取公钥，为了方便我在拿到公钥后直接存入localStorage中，所以在这里也要清空
    // localStorage.removeItem('publickey')
    // state.publickey=null
  }, */
  setRemark (state, remark) {
    state.remark = remark
    localStorage.setItem('remark', remark)
  },
  setZcount  (state, zcount) {
    state.zcount = zcount
    localStorage.setItem('zcount', zcount)
  },
  setNum  (state, num) {
    state.num = num
    localStorage.setItem('num', num)
  },
  setMultiple  (state, multiple) {
    state.multiple = multiple
    localStorage.setItem('multiple', multiple)
  },
  setBonus  (state, bonus) {
    state.bonus = bonus
    localStorage.setItem('bonus', bonus)
  },
  setMonery  (state, monery) {
    state.monery = monery
    localStorage.setItem('monery', monery)
  },
  setDcount  (state, dcount) {
    state.dcount = dcount
    localStorage.setItem('dcount', dcount)
  },
  setCount (state, count) {
    state.count = count
    localStorage.setItem('count', count)
  },
  setGgType (state, ggType) {
    state.ggType = ggType
    localStorage.setItem('ggType', ggType)
  },
  setGToggle (state, GToggle) {
    state.GToggle = GToggle
    localStorage.setItem('GToggle', GToggle)
  },
  setSelectedGToggle (state, selectedGToggle) {
    state.selectedGToggle = selectedGToggle
    localStorage.setItem('selectedGToggle', selectedGToggle)
  },
  updateCpTypeName (state, cpTypeName) {
    state.cpTypeName = cpTypeName
    localStorage.setItem('cpTypeName', cpTypeName)
  },
  setStart (state, start) {
    state.start = start
  },
  setEnd (state, end) {
    state.end = end
  }
}
const actions = {
  triggerRefresh ({ commit }, value) {
    commit('setRefreshData', value)
  }
}
const getters = {}
export default new Vuex.Store({
  modules,
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js